<div class="head" (click)="onMouseClick($event)">
  <div class="left-panel">
    <span class="imgcontainer" routerLink="/home" routerLinkActive="active"><img src="assets/images/logo.png"></span>
    <!-- <span class="desc" routerLink="/home" routerLinkActive="active" (click)="submit('autosave');"><fa-icon [icon]="faAngleLeft"></fa-icon> back to home</span> -->
    <span class="desc" routerLinkActive="active" (click)="submit('autosave');"><fa-icon [icon]="faAngleLeft"></fa-icon> back to home</span>
  </div>

  <div class="middle-panel">
    <div class="flex-row">
      <div class="Title" *ngIf='!editMode else editName' > {{ Message }}</div>
        <span *ngIf="!editMode && (route.snapshot.url[0].path == 'project' || route.snapshot.url[0].path == 'projectedit' || route.snapshot.url[0].path == 'importxml')" >
          <fa-icon class="check pointer" [icon]="faCheckCircle" (click)="toggleEdit()"></fa-icon>
        </span>
      <div class="m20b">
        <ng-template #editName>
          <input class="edit Title" type="text" [value]='Message' [(ngModel)]='Message' (keydown)="validateSpecialChar($event)">
          <span class="pointer" (click)="toggleEdit()"><img src="assets/images/lightEdit.png" width="25px"></span>
        </ng-template>
      </div>
    </div>

    <div *ngIf="sharedService.FromProgramSettings===false && sharedService.UserInfoMode === false">
      <div *ngIf="projectService.projectdetails.NewPath == '' && route.snapshot.url[0].path == 'project' || projectService.projectdetails.NewPath == '' && route.snapshot.url[0].path == 'projectedit' || projectService.projectdetails.NewPath == '' && route.snapshot.url[0].path == 'importxml'" class="flex-row path"><div class="pathString" *ngFor="let item of pathString"><fa-icon class="pathIcon" [icon]="faFolderOpen"></fa-icon> <span>{{item}}  /</span></div></div>
      <div *ngIf="projectService.projectdetails.NewPath != ''" class="flex-row path"><div class="pathString"><fa-icon class="pathIcon" [icon]="faFolderOpen"></fa-icon> <span>{{projectService.projectdetails.NewPath}}</span></div></div>
    </div>
  </div>


  <div  class="right-panel">
    <div *ngIf="sharedService.VisibleSaveClass=='VisibleSaveClass'" [ngClass]="Visible ? 'hideElement': ''" class="dropdown popupRectangle ripple">
      <div  class="fullFlex" (click)="submit(undefined)">
        <span> {{ Action }}</span>
      </div>
    </div>

    <div *ngIf="sharedService.VisibleSaveClass=='HideSaveClass' && sharedService.showSaveButton===true" [ngClass]="!Visible ? 'hideElement': ''" class="dropdown popupRectangle ripple">
      <div class="fullFlex" (click)="submit(undefined)">
        <span> {{ Action }}</span>
      </div>
    </div>

    <div id="divMoreOptionsBtn" *ngIf="route.snapshot.url[0].path == 'project' || route.snapshot.url[0].path == 'projectedit' ||route.snapshot.url[0].path == 'importxml'" class="nav-item dropdown popupRectangle" style="width:130px !important; font-size:15px;" ngbDropdown>
      <a class="nav-link dropdown-toggle fullFlex" (click)="addRemoveZIndex('remove')" id="moreOptionsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle style="color:white;">
        More Options
      </a>
      <ul class="dropdown-menu"  ngbDropdownMenu aria-labelledby="navbarScrollingDropdown" style="min-width:12rem;">
        <li ngbDropdownItem><a class="dropdown-item saveASclass" (click)="submit(undefined)"><img src="assets/images/save.png" class="pad10">Save</a></li>
        <li ngbDropdownItem><a class="dropdown-item saveASclass" data-toggle="modal" data-target="#saveas"><img src="assets/images/download.png" class="pad10">Save As</a></li>
        <li ngbDropdownItem><a class="dropdown-item saveASclass" (click)="prepareExportToXML('Export2XML')"><fa-icon [icon]="faFileExport" class="pad10"></fa-icon>Export Project</a></li>
        <li ngbDropdownItem><a class="dropdown-item saveASclass" (click)="prepareExportToXML('ShareProject')"><fa-icon [icon]="faShareAlt" class="pad10"></fa-icon>Share Project</a></li>
      </ul>
    </div>
    <!-- Modified by PP(2022-12-05) : Click twice - END -->

  </div>

  <!-- Modified by PP(2022-04-05) : To include Share and Export Project into More Options  - START -->
  <ng-template #templateShare let-modal class="templateShare">
    <div class="modal-content" style="width:120%;">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Share the project</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="initializeTeam(true)"> <!-- Modified by PP(2021-02-28) : Share XML -->
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                <div class="linkContent">
                    <input #linkT class="linkText" [value]="link" readonly>
                    <div class="button" (click)="copyLink2(link)">&nbsp;Copy Link&nbsp;
                      <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-start -->
                      <fa-icon [icon]='faInfoCircle' class="info" id="CopyInfoBtn"  (mouseleave)="showHideInfoToggle('copy')" (mouseenter)="showHideInfoToggle('copy')"></fa-icon>
                      <div id="CopyInfo" >
                        <div class="InfoContent2">
                          You may copy the link directly to use at your convenience.
                        </div>
                        <div id="arrow" data-popper-arrow></div>
                      </div>
                      <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-end -->
                    </div>
                </div>
            </div>
            <div class="seperator"><span>Invite Teammates</span></div>
        </div>
        <div class="row-1">
            <div class="flex-column-title">
                <div class="column-container">
                    <div class="column-content">
                        <div class="formgroup"> <label>Enter Full Name</label></div>
                    </div>
                 </div>
                <div class="column-container">
                    <div class="column-content">
                        <div class="formgroup"> <label>Enter Email Id</label></div>
                    </div>
                </div>
            </div>
            <div class="flex-column">
                <div class="column-container">
                    <div class="column-content">
                        <div class="row" *ngFor="let t of team">
                            <div class="formgroup">
                                <input type="text" placeholder="Joe Don" class="input-field" [(ngModel)]="t.Name">
                            </div>
                            <div class="formgroup">
                                <input type="text" placeholder="you@example.com" class="input-field" name="email"
                                    [(ngModel)]="t.Email">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="addBtn" (click)="addRow()" *ngIf="team.length<10"><span>Add Teammate</span></div>
        </div>
        <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-start -->
        <!-- <div class="next-button-content">
            <button class="button-content ripple" (click)='sendEmail()'>
                <span class='space'>Send Invite</span>
            </button>
        </div> -->
        <div *ngIf="loading===false" class="next-button-content">
          <button  class="button-content ripple" (click)='sendEmail()'>
              <span class='space'>Send Invite
                <fa-icon [icon]='faInfoCircle' class="info" id="SendInfoBtn"  (mouseleave)="showHideInfoToggle('send')" (mouseenter)="showHideInfoToggle('send')"></fa-icon>
                <div id="SendInfo" >
                    <div class="InfoContent2">
                      The "Send Invite" will send an email containing an URL link with input data of the project to the team mate(s). It will also send a copy to your mailbox as a reminder for you.<Br>
                      The URL can be copied and pasted into the "Import project" function at the start page.
                    </div>
                    <div id="arrow" data-popper-arrow></div>
                </div>
              </span>
          </button>
      </div>
      <div *ngIf="loading===true"  class="next-button-content" style="width:35%;">
        <button class="button-content ripple" style="background:#F1F5F2;color:#00673E;width:200px;" disabled>
          <span class='space'>Email is being procesed</span>
      </button>
    </div>
    <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-end -->
    </div>
  </ng-template>
  <!-- Modified by PP(2022-04-05) : To include Share and Export Project into More Options  - END -->

</div>
